<ng-container *ngIf="tooltip">
  <div
    class="c-popover-tooltip-html"
    [innerHtml]="tooltip.text | fetchImageFromHtmlPipe:tooltip['images'] | async | trustHtmlPipe"
  ></div>
</ng-container>